import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useRouter } from 'expo-router'
import { Feather } from '@expo/vector-icons'

import { FAQEnum } from '../faq.enum'
import { DS } from '../../../design-system'
import { Button } from '../../../components/ANewDesign/Button'
import { useRemoteConfig } from '../../../../module/remote-config/useRemoteConfig'

const STORE_PP_URL = 'http://store.pokerpower.com'
const answerWithLinkPPStore = 6

const FAQSection = () => {
  const router = useRouter()
  const isGoldMembershipEnabled = useRemoteConfig((state) => state.is_gold_membership_enabled)

  const teachingTablesQuestion = 2
  const liveClassesGoldMembershipQuestion = 3
  const upgradeSilverToGoldQuestion = 8

  const filteredFAQs = {
    benefits: isGoldMembershipEnabled
      ? FAQEnum.benefits
      : FAQEnum.benefits.filter(
          (faq) => faq.id !== teachingTablesQuestion && faq.id !== liveClassesGoldMembershipQuestion
        ),
    general: isGoldMembershipEnabled
      ? FAQEnum.general
      : FAQEnum.general.filter((faq) => faq.id !== upgradeSilverToGoldQuestion)
  }
  const Accordion = ({ title, description, id }: { title: string; description: string; id: number }) => {
    const [expanded, setExpanded] = React.useState(false)
    const toggleAccordion = () => {
      setExpanded(!expanded)
    }
    const answerWithLink = (id === answerWithLinkPPStore && description) || ''
    const [beforeLink, afterLink] = answerWithLink.split(STORE_PP_URL)

    return (
      <TouchableOpacity onPress={toggleAccordion} style={styles.accordionContainer}>
        <DS.Frame style={styles.accordionHeaderContainer}>
          <DS.Frame style={styles.accordionTitleContainer}>
            <DS.Text variant="Body Medium/Regular">{title}</DS.Text>
          </DS.Frame>
          <DS.Frame style={styles.accordionIconContainer}>
            <Feather name={expanded ? 'chevron-up' : 'chevron-down'} size={16} color={DS.palette['Brand/Dark Grey']} />
          </DS.Frame>
        </DS.Frame>
        {expanded &&
          (id === answerWithLinkPPStore ? (
            <DS.Frame style={styles.accordionDescription}>
              <DS.Text variant="Body Small/Regular">
                <DS.Text variant="Body Small/Regular" style={styles.faqTitle}>
                  {beforeLink}
                </DS.Text>

                <DS.Text variant="Body Small/Regular" style={styles.linkText} onPress={() => router.navigate('/store')}>
                  store.pokerpower.com
                </DS.Text>
                <DS.Text variant="Body Small/Regular" style={styles.faqTitle}>
                  {afterLink}
                </DS.Text>
              </DS.Text>
            </DS.Frame>
          ) : (
            <DS.Frame style={styles.accordionDescription}>
              <DS.Text variant="Body Small/Regular" style={styles.faqTitle}>
                {description}
              </DS.Text>
            </DS.Frame>
          ))}
      </TouchableOpacity>
    )
  }

  const Divider = () => <DS.Frame style={styles.divider} />

  return (
    <View style={styles.container}>
      <DS.Frame style={styles.faqContainer}>
        <DS.Text variant="Heading 5/Medium">FAQs</DS.Text>

        <DS.Frame style={styles.faqTitleContainer}>
          <DS.Text variant="Caption/Bold" style={styles.faqTitle}>
            GENERAL
          </DS.Text>
          <Divider />
        </DS.Frame>
        <DS.Frame>
          <DS.Frame style={styles.faqAccordionContainer}>
            {filteredFAQs?.general.map((faq) => (
              <Accordion key={faq.id} id={faq.id} title={faq.question} description={faq.answer} />
            ))}
          </DS.Frame>
        </DS.Frame>

        <DS.Frame style={styles.faqTitleContainer}>
          <DS.Text variant="Caption/Bold" style={styles.faqTitle}>
            PERKS & BENEFITS
          </DS.Text>
          <Divider />
        </DS.Frame>
        <DS.Frame style={styles.faqAccordionContainer}>
          {filteredFAQs?.benefits.map((faq) => (
            <Accordion key={faq.id} id={faq.id} title={faq.question} description={faq.answer} />
          ))}
        </DS.Frame>
        <DS.Frame style={styles.contactUsContainer}>
          <DS.Text variant="Body Medium/Regular">Questions about membership?</DS.Text>
          <DS.Frame style={styles.contactUsButonContainer}>
            <Button text="Contact Us" size="small" onPress={() => router.navigate('/contact')} />
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: DS.palette['Brand/Cream'],
    alignItems: 'center',
    paddingBottom: 24,
    position: 'relative'
  },
  heroContainer: {
    alignItems: 'center',
    transform: [{ translateY: -18 }],
    gap: 10
  },
  backButtonContainer: {
    position: 'absolute',
    top: 30,
    left: 0,
    padding: 24
  },
  pageSubTitle: {
    paddingHorizontal: 40,
    textAlign: 'center'
  },
  sectionContainer: {
    backgroundColor: DS.palette['Brand/Cream'],
    borderTopStartRadius: 24,
    borderTopEndRadius: 24,
    padding: 24,
    transform: [{ translateY: -24 }]
  },
  linkText: {
    color: '#007AFF',
    textDecorationLine: 'underline'
  },
  sectionTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },
  sectionSubtitle: {
    backgroundColor: `${DS.palette['Global/White']}80`,
    padding: 8,
    borderRadius: 12,
    flexDirection: 'row',
    gap: 8,
    marginTop: 12
  },
  faqContainer: {
    width: '100%',
    marginTop: 40
  },
  faqAccordionContainer: {
    backgroundColor: DS.palette['Brand/Cream'],
    gap: 8
  },
  faqTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 16,
    gap: 12
  },
  faqTitle: {
    color: DS.palette['Brand/Dark Grey']
  },
  contactUsContainer: {
    marginTop: 32
  },
  contactUsButonContainer: {
    marginTop: 8,
    width: 115
  },
  divider: {
    flex: 1,
    height: 1,
    backgroundColor: DS.palette['Brand/Light Grey']
  },
  accordionDescription: {
    paddingHorizontal: 16,
    paddingBottom: 16
  },
  accordionIconContainer: {
    flex: 1,
    alignItems: 'flex-end'
  },
  accordionTitleContainer: {
    width: '90%'
  },
  accordionHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    gap: 15
  },
  accordionContainer: {
    backgroundColor: `${DS.palette['Global/White']}80`,
    borderRadius: 12
  }
})

export default FAQSection
